module.exports = __webpack_public_path__ + "img/button.4e2c5530.png";